import * as React from "react";
import { Section } from "../ui/atoms/section";
import { FilterByDateRange } from "../ui/organisms/filter-by-date-range";
import { SelectionMode } from "@fluentui/react";
import { ListTruckEvents } from "../ui/molecules/list-truck-events";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

export class PageTruckActivity extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout breadcrumb={store.i18n.t("page.truckActivity.title")} classic>
                <Section fill>
                    <ListTruckEvents
                        commandBar={<FilterByDateRange onDateRangeChanged={() => {}} />}
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
